import { REGEX_CONSTANT } from "../../../constant/regexConstant";

export const validRole= (namespace, data, translate) => {
  let error = {};

  switch (namespace) {
    case "role_id":
      if (!data) {
        error[namespace] = translate("COMMON:REQUIRE", {
          field: translate("Role ID"),
        });
      }else if(data.length > 100){
        error[namespace] = translate("COMMON:MAX_LENGTH", {
          field: translate("Role ID"),
        });
      }else if(!REGEX_CONSTANT.ROLE_ID.test(data)){
        error[namespace] = translate("Invalid Format", {
          field: translate("Role ID"),
        });
      }  else {
        error[namespace] = null;
      }
      break;
      case "description":
        if (!data) {
          error[namespace] = translate("COMMON:REQUIRE", {
            field: translate("CUSTOMER:ADDITIONAL_DESCRIPTION"),
          });
        }else if(data.length > 225){
          error[namespace] = translate("COMMON:MAX_LENGTH", {
            field: translate("CUSTOMER:ADDITIONAL_NAME"),
          });
        }else if(!REGEX_CONSTANT.DESCRIPTION.test(data)){
          error[namespace] = translate("Invalid Format", {
            field: translate("Role ID"),
          });
        } else {
          error[namespace] = null;
        }
        break;
    default:
      break;
  }
  return error;
};
